<template>
  <div class="white_bg">
    <div class="filter_container">
      <div class="filter_item" v-if="filters && filters.letters && filters.letters.length">
        <div class="filter_attr">
          品牌：
        </div>
        <div class="filter_options">
          <div class="filter_option" 
            v-for="(item,ind) in filters.letters" 
            :key="ind"
            :class="item.letter == filters.letter ? 'checked':'' "
            @click="letterChange(item.letter)"
          >{{item.letter}}</div>
        </div>
      </div>
      <div class="filter_brands" v-if="filters && filters.brands && filters.brands.length">
        <div class="filter_brand" 
          v-for="(item,ind) in filters.brands"
          :key="ind"
          :class="item == filters.brand ? 'checked':'' "
          @click="brandChange(item)"
        >{{item}}</div>
    
      </div>
      <div class="filter_item"  v-if="filters && filters.systems && filters.systems.length">
        <div class="filter_attr">
          OS：
        </div>
        <div class="filter_options">
          <div class="filter_option"
            v-for="(item,ind) in filters.systems"
            :key="ind"
            :class="item.system == filters.system ? 'checked':'' "
            @click="systemChange(item.system)"
          >{{item.system}}</div>
        </div>
      </div>
      <div class="filter_item" v-if="filters && filters.times && filters.times.length">
        <div class="filter_attr">
          时间：
        </div>
        <div class="filter_options">
          <div class="filter_option"
            v-for="(item,ind) in filters.times"
            :key="ind"
            :class="item.year == filters.time ? 'checked':'' "
            @click="timeChange(item.year)"
          >{{item.year}}</div>
        </div>
      </div>
      <div class="filter_item" v-if="filters && filters.series && filters.series.length">
        <div class="filter_attr">
          车系：
        </div>
        <div class="filter_options">
          <div class="filter_option" :class="'' == filters.serie ? 'checked':'' " @click="serieChange('')">不限</div>
          <div class="filter_option"
            v-for="(item,ind) in filters.series"
            :key="ind"
            :class="item == filters.serie ? 'checked':'' "
            @click="serieChange(item)"
          >{{item}}</div>
        </div>
      </div>

      <div class="toReportList" >
          <router-link
            :to="{ path: '/service/downloads', query: {cur_category: 'OTA报告'} }"
          >
            OTA月报
          </router-link>  
        </div>
    </div>
    <!-- <div class="filter_checked">
      <div class="filter_attr">筛选条件：</div>
      <div class="filter_checked_options">
        <div class="filter_checked_option">蔚来</div>
        <div class="filter_checked_option">2020年</div>
        <div class="filter_checked_option">2020年</div>
      </div>
    </div> -->
    <div class="result_content" v-if="filters && filters.otaList && filters.otaList.length">
      <div class="result_version_line">
        <div class="result_version_item"
          v-for="(item,ind) in filters.otaList"
          :key="ind"
          @click="toOtaDetail(item)"
        >
        <template v-if="ind%2==0">
          <div class="result_version_num">
            {{item.version}}
          </div>
          <div class="result_version_desc">
            <template v-if="item.version_intro && item.version_intro.length">
              <template
                v-for="(intro_item,intro_ind) in item.version_intro"
                :key="intro_ind"
                >
                ● {{intro_item.title}}<br>
              </template>
            </template>
          </div>
          <div class="result_version_item_line"></div>
          <div class="result_version_item_circle"></div>
          <div class="result_version_time">
            {{item.upgrade_date}}
          </div>
        </template>
        <template v-else>
          <div class="result_version_time">
            {{item.upgrade_date}}
          </div>
          <div class="result_version_item_circle"></div>
          <div class="result_version_item_line"></div>
          <div class="result_version_desc">
            <template v-if="item.version_intro && item.version_intro.length">
              <template
                v-for="(intro_item,intro_ind) in item.version_intro"
                :key="intro_ind"
                >
                ● {{intro_item.title}}<br>
              </template>
            </template>
          </div>
          <div class="result_version_num">
            {{item.version}}
          </div>
        </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  reactive,
  // toRefs
} from "vue";
import {
  useRouter
} from "vue-router"
import {
  getBrandList,
  getBrandFilter,
  getOtaList
} from "@/api"
export default {
  name:"otaIndex",
  setup(){
    const filters = reactive({
      letters:[],
      letter:'',
      brands:[],
      brand:'',
      systems:[],
      system:'',
      times:[],
      time:'',
      series:[],
      serie:'',
      otaList:[]
    })
    const router = useRouter();
    const getBrandListFn = ()=>{
      getBrandList().then(res=>{
        filters.letters = res.data;
        res.data && res.data[0] && letterChange(res.data[0].letter)
        brandChange(res.data[0]['list'][0])
      })
    }
    const letterChange = (letter)=>{
      filters.letter = letter;
      filters.letters.forEach((item)=>{
        if(item.letter == letter){
          filters.brands = item.list;
        }
      })
      filters.brand = '';
      filters.systems=[];
      filters.system='';
      filters.times=[];
      filters.time='';
      filters.series=[];
      filters.serie='';
      filters.otaList=[];
    }
    const brandChange = (brand)=>{
      filters.brand = brand;
      getBrandFilter({
        brand
      }).then(res=>{
        console.log(res);
        filters.systems = res.data;
        // filters.system=filters.systems[0].system;
        // filters.times=filters.systems[0].year;
        filters.system='';
        filters.time='';
        filters.times=[];
        filters.series=[];
        filters.serie='';
        filters.otaList=[];
        filters.systems.length && filters.systems[0].system && systemChange(filters.systems[0].system)
       
      })
      
    }
    const systemChange = (system)=>{
      filters.system = system;
      filters.systems.forEach(item=>{
        if(item.system == system){
          filters.times = item.year;
          filters.series=[];
          filters.serie='';
          timeChange(filters.times[0].year)
        }
      })
      
      // filters.time='';
      // filters.series=[];
      // filters.serie='';
      filters.otaList=[];
    }
    const timeChange = (time)=>{
      filters.time = time;
      filters.times.forEach(item=>{
        if(item.year == time){
          filters.series = item.serie;
        }
      })
      filters.serie='';
      filters.otaList=[];
      serieChange('');
    }
    const serieChange = (serie)=>{
      filters.serie = serie;
      getOtaList({
        brand:filters.brand,
        system:filters.system,
        year:filters.time,
        serie:filters.serie
      }).then(res=>{
        console.log(res);
        filters.otaList=res.data;
      })
    }
    const toOtaDetail = (ota_item)=>{
      router.push({
        path:"/service/ota/detail",
        query:{
          id:ota_item.id
        }
      })
    }
    getBrandListFn();
    return {
      filters,
      // ...toRefs(filters),
      letterChange,
      brandChange,
      systemChange,
      timeChange,
      serieChange,
      toOtaDetail
    }
  }
}
</script>

<style lang="less" scoped>
.white_bg{
  min-height: calc(100vh - 128px);
  padding: 48px 56px 48px 59px;
}
.filter_container{
  .filter_item{
    background: #F6F9FD;
    border-radius: 2px;
    display: flex;
    margin-bottom: 15px;
    .filter_attr{
      flex-shrink: 0;
      min-width: 103px;
      height: 50px;
      line-height: 50px;
      padding: 0 19px 0 40px;
      font-size: 14px;
      font-weight: bold;
      color: #191919;
    }
    .filter_options{
      display: flex;
      flex-wrap: wrap;
      padding-top: 13px;
      .filter_option{
        cursor: pointer;
        height: 24px;
        line-height: 24px;
        margin-bottom: 13px;
        margin-right: 7px;
        border-radius: 1px;
        padding: 0 10px;
        font-size: 14px;
        color: #191919;
        &.checked {
          background: #1FBCBF;
          color: #fff;
        }
        &:hover{
          background: #1FBCBF;
        }
      }
    }
  }
  .filter_brands{
    width: 100%;
    display: flex;
    padding: 6px 0 6px 33px;
    .filter_brand{
      cursor: pointer;
      padding: 0 8px;
      margin-right: 20px;
      margin-bottom: 12px;
      font-size: 14px;
      color: #191919;
      &.checked{
        color: #1FBCBF;
        border-radius: 1px;
        border: 1px solid #1FBCBF;
      }
    }
  }
}
// .filter_checked{
//   display: flex;
//   .filter_attr{
//     flex-shrink: 0;
//     min-width: 103px;
//     height: 50px;
//     line-height: 50px;
//     padding: 0 19px 0 40px;
//     font-size: 14px;
//     font-weight: bold;
//     color: #191919;
//   }
//   .filter_checked_options{
//     display: flex;
//   }
// }
.result_content{
  width: 1128px;
  height: 415px;
  overflow-x: auto;
  overflow-y: hidden;
  display: flex;
  align-items: center;
  border-top: 1px solid #E1E1E1;
  .result_version_line{
    flex: 1;
    width: auto;
    height: 1px;
    background: #1FBCBF;
    display: flex;
    align-items: center;
    .result_version_item{
      width: 168px;
      height: 415px;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-right: 23px;
      .result_version_num{
        height: 59px;
        font-size: 14px;
        font-weight: bold;
        color: #D35E5E;
        line-height: 19px;
      }
      .result_version_desc{
        width: 168px;
        height: 104px;
        padding: 4px 6px;
        border: 1px solid #D4D4D4;
        font-size: 12px;
        color: #2A2A2A;
        line-height: 19px;
        white-space: pre-line;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
        display: -webkit-box;
        -webkit-line-clamp: 5;
        -webkit-box-orient: vertical;
        cursor: pointer;
        &:hover{
          background: #F6F9FD;
        }
      }
      .result_version_item_line{
        width: 1px;
        height: 39px;
        background:#D4D4D4;
      }
      .result_version_item_circle{
        width: 14px;
        height: 14px;
        border-radius: 50%;
        background: #1FBCBF;
        border: 4px solid #FFFFFF;
      }
      .result_version_time{
        height: 201px;
        font-size: 14px;
        color: #000000;
      }

      &:nth-child(odd){
        .result_version_num{
          line-height: 85px;
        }
        .result_version_time{
          line-height: 21px;
        }
      }
      &:nth-child(even){
        .result_version_num{
          line-height: 37px;
        }
        .result_version_time{
          line-height: 380px;
        }
      }
    }
  }
}
.toReportList {
  text-align: center;
}
</style>